<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DutdnX/Images/MSRCover.jpg?1739571356672" alt="This image is the cover for the book Family in His Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family in His Heart
      </h1>
      <p class="bookDescription body article font2">
        <b>Who Wasn't Trying To Fix Up  Dr. Zack Hemingway?</b><br/><br/>Even his boss had handpicked two of his three daughters as perfect candidates for the position of Zack's wife. But it was the other daughter who'd caught Zack's no-longer roving eye.<br/><br/>A sweet Christian woman who worked with children in need, Chloe Kilgannon possessed everything he wanted in a wife. Except a willingness to say I do. Why? What was Chloe hidingor hiding from? Zack had to find out before he lost Chloe for good. For when his own family dropped a life-changing bombshell on him, he knew that some secrets were truly meant to be shared. <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gail Gaymer Martin
      </h2>
      
      <p class="authorDescription body article">Award-winning novelist, Gail Gaymer Martin authored over 80 novels with 4 million books in print, receiving a Carol and 2 RT Reviewer Choice Awards. Her novel THE CHRISTMAS KITE was optioned for a Hallmark movie. Gail authored Writers Digest&#39;s WRITING THE CHRISTIAN ROMANCE and is a co-founder of American Christian Fiction Writers. CBS local news named her as the four best novelists in Detroit. Before publication, Gail worked as a counselor and a university instructor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4637f08b